import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as instructorApi from '@/apis/instructors';

// 쿼리 키 상수화
export const INSTRUCTOR_KEYS = {
    all: ['instructors'],
    lists: () => [...INSTRUCTOR_KEYS.all, 'list']
}

/* ==========================================
    Queries (GET)
========================================== */

// 1. 강사 목록 조회
export const useInstructorList = () => {
    return useQuery({
        queryKey: INSTRUCTOR_KEYS.lists(),
        queryFn: () => instructorApi.fetchInstructorList(),
    });
}